module.exports = "/images/map-marker.svg?9b3167c55f34626532a866d587372595";